import "core-js/modules/es7.promise.finally";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/panier.svg';

const AddToCartModal = () => import(
/* webpackMode: "eager" */
'~/components/molecules/Product/Modal/AddToCartModal.vue');

export default {
  name: 'TheCartSection',
  components: {
    AddToCartModal
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      showModal: false,
      btnDisabled: false
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    cartTracking() {
      return {
        fn: 'add-to-cart',
        data: {
          product_id: this.product.reference,
          product_name: this.product.name,
          product_category: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5),
          product_brand: window.tc_vars.product_brand,
          product_variant: window.tc_vars.product_variant || '',
          product_totalprice_ati: window.tc_vars.product_totalprice_ati,
          product_quantity: 1,
          product_activity: window.tc_vars.product_activity,
          page_product: 'FicheProduit',
          product_style: window.tc_vars.product_style,
          product_room: window.tc_vars.product_room
        }
      };
    }

  }),
  methods: _objectSpread({}, mapActions({
    addCart: 'cart/add'
  }), {
    addToCart(qty, event) {
      this.trackAddToCart(event);
      this.btnDisabled = true;
      this.addCart({
        reference: this.product.reference,
        referenceEncoded: btoa(this.product.reference),
        offer: this.product.offer ? this.product.offer.reference : null,
        quantity: qty
      }).then(() => {
        this.showModal = true;
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        this.btnDisabled = false;
      });
    },

    trackAddToCart(event) {
      this.$root.$emit('generic-tracking', event, this.cartTracking);

      if (this.$cookies.get('algolia')) {
        try {
          const payload = JSON.parse(localStorage.getItem('algoliaLastEvent'));

          if (payload.objectIDs[0] === this.product.reference) {
            window.aa('convertedObjectIDsAfterSearch', _objectSpread({}, payload, {
              eventName: 'add_cart_product_page'
            }));
          }

          localStorage.removeItem('algoliaLastEvent');
        } catch (err) {
          console.log(err);
        }
      }
    },

    closeAction() {
      this.showModal = false;
    },

    handleAddToCartCta(event) {
      this.addToCart(1, event);
    }

  })
};